import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { ArrowRight, Lock, Loader2 } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { api } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  if (localStorage.getItem('adminToken')) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/admin/login', { password });
      localStorage.setItem('adminToken', res.data.token);
      navigate('/admin', { replace: true });
    } catch (err) {
      toast({
        title: 'Login failed',
        description: err.response?.data?.detail || 'Invalid password',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-alt)] flex items-center justify-center px-6">
      <form onSubmit={submit} className="bg-white rounded-2xl border border-[var(--line-2)] p-8 w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6">
          <Lock className="w-4 h-4 text-ink" />
          <div className="text-sm font-semibold text-ink">BriefingIQ Admin</div>
        </div>
        <h1 className="text-2xl font-semibold text-ink tracking-tight mb-6">Sign in</h1>
        <div className="mb-5">
          <Label className="text-[11px] uppercase tracking-wider text-ink-3">Password</Label>
          <Input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 rounded-lg border-[var(--line-2)]"
            placeholder="Admin password"
            autoFocus
          />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
          {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : <>Sign in <ArrowRight className="w-4 h-4" /></>}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
